import {
  loadShaders,
  shaderVars,
  renderRacer,
  loadDefaultShaders,
  getShaderName,
} from '@blockracers/util';
import createEnvironment from '../createEnvironment';
import { Draw, Words, calculateWidth } from '@a4m/graphics';

import {
  Color4,
  Engine,
  Effect,
  Scene,
  Vector3,
  ArcRotateCamera,
  DirectionalLight,
  ShadowGenerator,
  MeshBuilder,
} from '@babylonjs/core';

import { ShadowOnlyMaterial } from '@babylonjs/materials';

const loadRacer = true;

(async function () {
  if (!loadRacer) return;

  const racerData = await fetch(`/asset/${assetUrl.split('//ipfs/')[1]}`).then(
    res => res.json()
  );

  const canvas = document.createElement('canvas');
  canvas.id = 'racer-3d';
  const container = document.querySelector('.view-racer');
  container.innerHTML = '';
  container.appendChild(canvas);

  const engine = new Engine(canvas, true, {}, true);

  window.addEventListener('resize', function () {
    engine.resize();
  });

  let camera;

  const createScene = async function () {
    // Create the scene space
    const scene = new Scene(engine);

    scene.shadowsEnabled = true;

    camera = new ArcRotateCamera(
      'Camera',
      (-3 * Math.PI) / 4,
      Math.PI / 4,
      10,
      new Vector3(0, 2, 0),
      scene
    );

    camera.position = new Vector3(-20, 5, 0);
    camera.upperBetaLimit = Math.PI / 1.6;
    camera.lowerBetaLimit = 0;

    camera.attachControl(canvas, true);
    camera.lowerRadiusLimit = camera.radius;
    camera.upperRadiusLimit = camera.radius;
    camera.wheelPrecision = 50;
    camera.panningSensibility = 0;

    const shadowGenerators = [];

    for (let i = 0; i < shaderVars.lightPositions.length; i += 3) {
      const position = new Vector3(
        shaderVars.lightPositions[i],
        shaderVars.lightPositions[i + 1],
        shaderVars.lightPositions[i + 2]
      );
      var light = new DirectionalLight('dir01', position.negate(), scene);
      light.position = position;

      light.intensity = shaderVars.ambientLightStrength;

      light.autoUpdateExtends = false;
      light.shadowMinZ = 10;
      light.shadowMaxZ = 70;

      const shadowGenerator = new ShadowGenerator(1024, light);

      // shadowGenerator.usePoissonSampling = true;
      // shadowGenerator.useBlurCloseExponentialShadowMap = true;
      // shadowGenerator.forceBackFacesOnly = true;
      // shadowGenerator.blurKernel = 5;
      // shadowGenerator.useKernelBlur = true;
      //
      // Freeze shadows
      // shadowGenerator.getShadowMap().refreshRate =
      //   RenderTargetTexture.REFRESHRATE_RENDER_ONCE;

      shadowGenerators.push(shadowGenerator);
    }

    scene.clearColor = new Color4(0, 0, 0, 0); //.FromHexString("#93C4D6");

    const envMesh = createEnvironment(scene, racerData.colors[0]);
    envMesh.position = new Vector3(0, 0, 0);

    const ground = MeshBuilder.CreateGround(
      'ground',
      { width: 50, height: 50 },
      scene
    );

    ground.position = new Vector3(0, 0, 0);
    ground.receiveShadows = true;

    var groundMaterial = new ShadowOnlyMaterial('ground', scene);
    ground.material = groundMaterial;

    loadDefaultShaders(Effect);
    // todo: fix

    console.log(racerData.shaders, racerData.meta, racerData.version);
    loadShaders(
      racerData.version !== 1.1
        ? racerData.shaders.map(shader => ({
            ...shader,
            // name: shader.name,
            name: getShaderName(shader.name, racerData.meta.name),
          }))
        : Object.values(racerData.shaders).map(shader => ({
            ...shader,
            // name: shader.shader,
            name: getShaderName(shader.shader, racerData.meta.name),
          })),
      Effect
    );

    const { racerMesh, blocks } = await renderRacer(racerData, scene);

    racerMesh.position = new Vector3(-3, 2, 0);

    shadowGenerators.forEach(shadowGenerator => {
      shadowGenerator.addShadowCaster(racerMesh, true);
    });

    return scene;
  };

  const scene = await createScene(); //Call the createScene function

  scene.beforeRender = () => (camera.alpha += 0.003);

  // Register a render loop to repeatedly render the scene
  engine.runRenderLoop(function () {
    scene.render();
  });

  const titleHeight = 70;

  const width = calculateWidth(
    'sixth',
    titleHeight,
    racerData.meta.name.toUpperCase()
  );

  const draw = Draw({
    canvas: document.querySelector('.racer-title'),
    width,
    height: titleHeight,
  });

  const staticWords = Words(draw);

  staticWords({
    // typeface: racerData.meta.specialEdition ? "sixth" : "sixth",
    typeface: 'sixth',
    height: titleHeight,
    noise: 24,
    colors: {
      primary: racerData.colors[2],
      secondary: racerData.colors[2],
    },
    x: 0,
    y: 0,
    content: `${''}${racerData.meta.name.toUpperCase()}`,
  });
})();
